import api, { mailerServiceApi } from 'services/api';
import { GET, POST, PUT, DELETE, templateRoutes } from 'constants/api';

const MISSING_TEMPLATE_ID = 'Template id is missing';
const MISSING_CATEGORY_ID = 'Category id is missing';

const checkTemplateId = templateId => {
  if (!templateId && templateId !== 0) {
    throw new Error(MISSING_TEMPLATE_ID);
  }
};

const checkCategoryId = categoryId => {
  if (!categoryId && categoryId !== 0) {
    throw new Error(MISSING_CATEGORY_ID);
  }
};

export const getTemplates = ({
  search,
  page,
  limit,
  categoryId,
  activeOnly,
  ampOnly,
  emailTypeId,
  sortColumn,
} = {}) =>
  api({
    method: GET,
    url: templateRoutes.GET_TEMPLATES,
    params: {
      page,
      limit,
      search,
      categoryId,
      activeOnly,
      ampOnly,
      emailTypeId,
      sortColumn:
        sortColumn && Object.values(sortColumn).length > 0
          ? encodeURIComponent(JSON.stringify(sortColumn))
          : null,
    },
  });

export const countTemplates = ({ search, categoryId, activeOnly, ampOnly }) =>
  api({
    method: GET,
    url: templateRoutes.COUNT_TEMPLATES,
    params: { search, categoryId, activeOnly, ampOnly },
  }).then(data => data.count);

export const getTemplateEditHistory = templateId => {
  checkTemplateId(templateId);
  return api({
    method: GET,
    url: templateRoutes.GET_TEMPLATE_EDIT_HISTORY(templateId),
  });
};

export const getTemplateById = templateId => {
  return api({
    method: GET,
    url: templateRoutes.GET_TEMPLATE_BY_ID(templateId),
  });
};

export const getTemplateInCategory = categoryId => {
  checkCategoryId(categoryId);
  return api({
    method: GET,
    url: `${templateRoutes.GET_TEMPLATES_IN_CATEGORY}${categoryId}`,
  });
};

export const addTemplate = data =>
  api({
    method: POST,
    url: templateRoutes.ADD_TEMPLATE,
    data,
  });

export const editTemplate = data => {
  checkTemplateId(data.id);
  return api({
    method: PUT,
    url: `${templateRoutes.EDIT_TEMPLATE}${data.id}`,
    data,
  });
};

export const reactivateTemplate = templateId => {
  checkTemplateId(templateId);
  return api({
    method: POST,
    url: templateRoutes.REACTIVATE_TEMPLATE(templateId),
  });
};

export const validateHtmlTemplateV2 = data => {
  return api({
    method: POST,
    url: `${templateRoutes.VALIDATE_HTML_TEMPLATE_V2}`,
    data,
  });
};

export const deleteTemplate = templateId => {
  checkTemplateId(templateId);
  return api({
    method: DELETE,
    url: `${templateRoutes.DELETE_TEMPLATE}${templateId}`,
  });
};

export const generateTemplateReport = () => {
  return api({
    method: POST,
    url: `${templateRoutes.GENERATE_TEMPLATE_REPORT}`,
  });
};

export const templateReportStatus = () => {
  return api({
    method: GET,
    url: `${templateRoutes.TEMPLATE_REPORT_STATUS}`,
  });
};

export const generalTemplateReport = () => {
  return api({
    method: GET,
    url: `${templateRoutes.GENERAL_TEMPLATE_REPORT}`,
  });
};

export const topUnoptimizedTemplates = () => {
  return api({
    method: GET,
    url: `${templateRoutes.TOP_UNOPTIMIZED_TEMPLATES}`,
  });
};

export const topUnoptimizedCategories = () => {
  return api({
    method: GET,
    url: `${templateRoutes.TOP_UNOPTIMIZED_CATEGORIES}`,
  });
};

export const setTemplateDailyQuota = ({ templateId, quota }) => {
  return mailerServiceApi({
    method: POST,
    url: templateRoutes.SET_TEMPLATE_QUOTA(templateId, quota),
  });
};
